import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Environment } from '../../../config/environment';

@Component({
	selector: 'app-maintenance',
	templateUrl: './maintenance.component.html',
	styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnDestroy {
	constructor(
		private environment: Environment,
		private router: Router
	) {
		document.body.classList.add('maintenance');
		if (this.environment.getEnvironment().UNDER_MAINTENANCE !== 'true') {
			this.router.navigate(['/']);
		}
	}

	get maintenanceSchedule(): string {
		const env = this.environment.getEnvironment();
		const from = env.MAINTENANCE_FROM?.trim();
		const to = env.MAINTENANCE_TO?.trim();
		return from && to ? `${from} – ${to}` : '';
	}

	get currentYear(): number {
		return new Date().getFullYear();
	}

	refreshPage(): void {
		window.location.reload();
	}

	openCookiePreferences(event: Event): void {
		event.preventDefault();
		window['Osano']?.cm?.showDrawer?.('osano-cm-dom-info-dialog-open');
	}

	ngOnDestroy(): void {
		document.body.classList.remove('maintenance');
	}
}
